exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".microsoftYaHei[data-v-5f734f85]{font-family:Microsoft YaHei regular}", ""]);

// exports
